export default __webpack_public_path__ + "static/media/icon_nmt.5f97a3de.svg";